import { FC } from 'react'
import { TIPO_ESCALA_LABELS } from '../core/escalaHelpers'
import { TipoEscala } from '../core/_models'
import { IconPaths, KTSVG } from '_metronic/helpers'

type Props = {
  tipo: TipoEscala
}

/**
 * Selo de tipo da escala. Traz **sempre** ícone + texto: a cor de fundo é
 * reforço, não o portador do significado (BRAND.md / WCAG 2.2 AA).
 *
 * `text-success-emphasis` troca a cor-base do `badge-light-success` (1,92:1) pelo
 * par legível do tema.
 */
export const TipoEscalaBadge: FC<Props> = ({ tipo }) => {
  const disponibilidade = tipo === TipoEscala.Disponibilidade

  return (
    <span
      className={`badge gap-1 ${
        disponibilidade ? 'badge-light-success text-success-emphasis' : 'badge-secondary'
      }`}
    >
      <KTSVG
        path={disponibilidade ? IconPaths.CircleCheck : IconPaths.CircleSlash}
        className='svg-icon-em'
        ariaHidden
      />
      {TIPO_ESCALA_LABELS[tipo] ?? tipo}
    </span>
  )
}
